import { Component, ViewContainerRef, ElementRef, ViewChild } from '@angular/core';
import { UrlRedirection } from '../../models/shared/url-redirection.model';
import { UrlRedirectionService } from '../../services/url-redirection/url-redirection.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { UtilitiesService } from '../../services/shared/utilities.service';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { Router } from '@angular/router';
import { HttpClient, HttpRequest, HttpEventType, HttpEvent } from '@angular/common/http';
import { ProductService } from '../../services/product/product.service';
@Component({
  selector: 'app-manage-url-redirection',
  templateUrl: './manage-url-redirection.component.html',
  styleUrls: ['./manage-url-redirection.component.css']
})
/** manage-url-redirection component*/
export class ManageUrlRedirectionComponent {
  public urlRedirection = new UrlRedirection();
  // For Cost List
  urlRedirectionList: UrlRedirection[];
  public redirectionTypes: string[];
  //Filter items from grid
  filteredItems: any[];
  public rowsOnPage: number;
  public arrRowsPerPage: number[];
  public btnName: string;
  public IsFormLoaded: boolean = false;
  public searchKeyword: string;
  public redirectionType: string;
  public message: string;
  public excelColumns: string[];
  public urlColumns: string[];
  public isFileUploaded: boolean;
  public FormDataFile: FormData;
  public dict = [];
  public timerSyncCount: any;
  public isSubmit: boolean = true;
  public notFileMsg: boolean = false;
  public msg = {
    detail: "",
    exception: "",
    data: []
  };
  @ViewChild('file') btnFile: ElementRef;
  constructor(private readonly urlRedirectionService: UrlRedirectionService,
    private readonly toastr: ToastsManager,
    private readonly utilitiesService: UtilitiesService,
    vcr: ViewContainerRef, private readonly router: Router, private readonly rolePermissionService: RolePermissionService, private readonly productService: ProductService) {
    this.checkPermission();
    this.toastr.setRootViewContainerRef(vcr);
    this.GetUrlRedirectionList();
    this.GetRowsPerPageList();
    this.GetRedirectionTypes();
    this.IsFormLoaded = true;
    this.IntializeValues();
    this.redirectionType = "";
    this.isFileUploaded = false;
    this.FormDataFile = new FormData();
    this.excelColumns = [];
    this.urlColumns = [];
    this.populateUrlColumns();
  }
  checkPermission() {
    this.rolePermissionService.GetRolePermissions("manageurlredirect").subscribe(
      data => {
        if (data != null) {
          var list = data.filter(function (element) {
            return (element.action == "list");
          });
          if (list.length > 0) {

          }
          else {
            this.router.navigate(["/"]);
          }
        }
        else {
          this.router.navigate(["/"]);
        }
      }
    )
  }
  //For cost List
  GetUrlRedirectionList() {
    this.urlRedirectionService.GetUrlRedirections().subscribe(data => {
      this.urlRedirectionList = data;
      //this.filteredItems = data;
      this.OnFilterChange();
    });
  }
  GetRedirectionTypes() {
    this.urlRedirectionService.GetRedirectionTypes().subscribe(
      data => {
        this.redirectionTypes = data;
      }
    )
  }
  // Populate the row per page list
  GetRowsPerPageList() {
    this.arrRowsPerPage = this.utilitiesService.GetRowsPerPageList();
    this.rowsOnPage = this.arrRowsPerPage[0];
  }
  OnFilterChange() {
    this.filteredItems = this.urlRedirectionList;

    if (this.redirectionType != "") {
      this.filteredItems = this.filteredItems.filter(s => s.type == this.redirectionType);
    }
    if (this.searchKeyword != "" && this.searchKeyword != null) {
      this.filteredItems = this.utilitiesService.GetSearchedResult(this.filteredItems, this.searchKeyword);
    }

  }
  //Edit Functionality
  EditUrl(id: string) {
    this.IsFormLoaded = false;
    this.urlRedirectionService.GetUrlRedirectionById(id).subscribe(data => {
      this.urlRedirection = data;
      this.btnName = "<i class='fa fa-refresh'></i> Update";
      this.IsFormLoaded = true;
    });
    try {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    } catch (e) {
      window.scrollTo(0, 0);
    }
  }
  //delete Functionality
  DeleteUrlRedirection(id) {
    var ans = confirm("Are you sure to delete this url? ");
    if (ans) {
      this.urlRedirectionService.DeleteUrlRedirection(id).subscribe(result => {
        this.toastr.success('Url Redirection deleted successfully.', 'Success');

        this.IntializeValues();
        this.GetUrlRedirectionList();
      });

    }
  }
  ChangeButtonName() {
    this.btnName = "<i class='fa fa-save'></i> Save";
    this.urlRedirection.id = "";
  }
  IntializeValues() {
    this.urlRedirection.isActive = true;
    this.urlRedirection.type = "";
    this.urlRedirection.oldUrl = "";
    this.urlRedirection.newUrl = "";
    this.btnName = "<i class='fa fa-save'></i> Save";
  }
  onSubmit() {
    if (this.urlRedirection.isActive == null) {
      this.urlRedirection.isActive = false;
    }
    this.urlRedirectionService.AddUrlRedirection(this.urlRedirection).subscribe(result => {
      if (this.urlRedirection.id != null && this.urlRedirection.id != "") {
        this.toastr.success('Redirection Url updated successfully.', 'Success');
      } else {
        this.toastr.success('Redirection Url saved successfully.', 'Success');
      }
      this.GetUrlRedirectionList();
      let btnReset: HTMLElement = document.getElementById('btnReset') as HTMLElement;
      btnReset.click();
      //this.IntializeValues();
    });
  }
  ImportFile() {
    if (this.dict.length != this.excelColumns.length) {
      this.toastr.warning('All columns has not been mapped', 'Note');
    }
    else {

      // this.toastr.success('All columns has been mapped', 'Note'); 
      this.FormDataFile.append('dictionary', JSON.stringify(this.dict));
      this.isSubmit = true;
      this.urlRedirectionService.ReadCompleteFile(this.FormDataFile).subscribe(d => {
        this.excelColumns = [];
        this.isFileUploaded = false;
        //this.msg.exception = d.exception;
       // this.msg.detail = d.detail;
        this.msg.data = d.data;
        if (d.success) {
          this.btnFile.nativeElement.value = "";
          this.msg.detail = d.detail;
          this.toastr.success(d.detail, 'Success');
            setTimeout(() => {
              this.GetUrlRedirectionList();
            }, 1000);
         
        }
        else {
          this.isSubmit = false;
          this.toastr.error(d.detail);
        }
      });
    }
  }
  populateUrlColumns() {
    return this.urlRedirectionService.getUrlColumns().subscribe(data => {
      this.urlColumns = data;
      this.dict = [];
      for (var i = 0; i < data.length; i++) {
        this.updateitemInDictinoray(data[i], data[i]);
      }
    });
  }

  updateitemInDictinoray(keyItem: any, valueItem: any) {
    var previousItem = this.dict.findIndex(i => i.key == keyItem);
    //adding new item
    if (previousItem == -1) {
      this.dict.push({
        key: keyItem,
        value: valueItem
      });
    }
    if (previousItem => 0) {
      this.dict.splice(previousItem, 1);
      this.dict.push({
        key: keyItem,
        value: valueItem
      });
    }
  }
  genrateColumns(files) {
    if (files.length === 0) {
      return;
    }
    this.isSubmit = false;
    const formData = new FormData();
    this.notFileMsg = true;
    for (let file of files)
      formData.append(file.name, file);
    this.FormDataFile = formData;
    this.urlRedirectionService.GetColumnsUploadFile(formData).subscribe(data => {
      this.excelColumns = data;
      if (this.excelColumns.length > 0) {
        this.isFileUploaded = true;
      }
      else {
        this.isFileUploaded = false;
      }
    });
  }
  ifNotSelected(valuestring: string) {
    return this.dict.indexOf(i => i.key == valuestring) >= 0;
  }

}



// WEBPACK FOOTER //
// ./src/app/url-redirection/manage-url-redirection/manage-url-redirection.component.ts